import {Avatar, Stack, Typography} from '@mui/material';
import styled, {css} from 'styled-components';
import {StyledClientType} from './types';

export const StyledContainer = styled(Stack)<StyledClientType>`
  width: 100%;
  max-width: 648px;
  flex-direction: row;
  gap: 8px;
  opacity: 0;
  animation: fadeInUp 0.3s ease-out forwards;
  ${({$isClient}) =>
    $isClient
      ? css`
          flex-direction: row-reverse;
        `
      : null}
  @keyframes fadeInUp {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const StyledBubbleContainer = styled(Stack)<StyledClientType>`
  flex: 1;
  justify-content: center;
  min-height: 52px;
  background-color: ${({theme}) => theme.colors.brand.primary.white};
  padding: 8px 16px;
  border-radius: 8px;
  gap: 8px;
  ${({theme}) => theme.breakpoints.down(375)} {
    max-width: 290px;
  }
  ${({$isClient, $isMobile, theme}) =>
    $isClient
      ? css`
          flex: ${$isMobile ? 1 : 0.5};
          background-color: ${theme.colors.light.info['190Percent']};
        `
      : null};
`;

export const StyledDescription = styled(Typography)<StyledClientType>`
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.575rem;
  color: ${({theme}) => theme.colors.light.text.primary};
  ${({$isClient}) =>
    $isClient
      ? css`
          font-size: 0.875rem;
          line-height: 1.25rem;
          color: ${({theme}) => theme.colors.light.info['160Percent']};
        `
      : null}
`;

export const StyledSubDescription = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: ${({theme}) => theme.colors.light.text.secondary};
`;

export const StyledAvatar = styled(Avatar)`
  background-color: ${({theme}) => theme.colors.brand.primary.white};
  width: 30px;
  height: 30px;
`;
